<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="phone-modal"
        ok-disabled
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <div class="contact-us contact-details">
                <h3>Call on:</h3>
                <h1><a :href="`tel:${carrierDetails.phone}`" class="text-primary font-weight-bold text-decoration-none">{{ carrierDetails.phone }}</a></h1>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "PhoneModal",

    props: ['carrierDetails']
}
</script>

<style scoped>

</style>